<header class="col-12 header-page row">
    <h1 class="col-sm-12 col-md-7 col-xl-7 px-0 header__page__content__title">
        Solicitar Declaração
    </h1>
    <div class="col-sm-12 col-md-5 col-xl-5 px-1 px-0">
        <a type="button" [routerLink]="['/historico-solicitacao']" [queryParams]="{ productId: formData.value.product }"
            class="btn btn-outline-primary btn-outline-primary-historico float-right">
            <span>Histórico Declarações</span>
        </a>
    </div>
</header>
<main class="col-sm-12 col-xl-12 main__content">
    <section>
        <form class="mt-2" [formGroup]="formData" (ngSubmit)="gerarDeclaracao()">
            <section class="row col-xl-12 col-lg-12 col-md-12 col-sm-12 content__form">
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field" [@fadeIn]>
                    <label class="page__content__field__label">
                        Produto <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="description" bindValue="id" [searchable]="false"
                        placeholder="Selecione o Produto" notFoundText="Não há items" loadingText="Carregando..."
                        [clearable]="false" [items]="productsList" (change)="onProductChange()"
                        formControlName="product">
                    </ng-select>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field"
                    *ngIf="formData.get('product')?.valid" [@fadeIn]>
                    <label class="page__content__field__label">
                        Modelo da Declaração <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="description" bindValue="id" [searchable]="false"
                        placeholder="Selecione o Modelo" notFoundText="Não há items" loadingText="Carregando..."
                        [clearable]="false" [items]="modelsList" (change)="onModelChange()" formControlName="model">
                    </ng-select>
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formData.get('model')?.touched && formData.get('model')?.invalid">
                        O campo Modelo é obrigatório!
                    </small>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field"
                    *ngIf="showValues('beneficiary')" [@fadeIn]>
                    <label class="page__content__field__label">
                        Beneficiário (a) <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="name" bindValue="id" [searchable]="false"
                        placeholder="Selecione o (a) Beneficiário (a)" notFoundText="Não há items"
                        loadingText="Carregando..." [loading]="loadingFilter" [clearable]="false"
                        [items]="beneficiaries" (change)="onBeneficiaryChange()" formControlName="beneficiary">
                    </ng-select>
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formData.get('beneficiary')?.touched && formData.get('beneficiary')?.invalid">
                        O campo Beneficiado é obrigatório!
                    </small>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field"
                    *ngIf="showValues('dependent')" [@fadeIn]>
                    <label class="page__content__field__label">
                        Dependente <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="name" bindValue="id" [searchable]="false"
                        placeholder="Selecione o Dependente" notFoundText="Não há items" loadingText="Carregando..."
                        [loading]="loadingFilter" [clearable]="false" [items]="dependents" formControlName="dependent">
                    </ng-select>
                    <small class="page__content__field__alert"
                        *ngIf="formData.get('dependent')?.touched && formData.get('dependent')?.invalid">
                        O campo Dependente é obrigatório!
                    </small>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field" *ngIf="showValues('year')">
                    <label class="page__content__field__label" [@fadeIn]>
                        Ano <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="description" bindValue="description" [searchable]="false"
                        placeholder="Selecione o Ano" notFoundText="Não há items" loadingText="Carregando..."
                        [clearable]="false" [items]="yearsList" (change)="onYearChange()" formControlName="year">
                    </ng-select>
                    <small class="page__content__field__alert"
                        *ngIf="formData.get('year')?.touched && formData.get('year')?.value == null">
                        O campo Ano é obrigatório!
                    </small>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field"
                    *ngIf="showValues('initialMonth')" [@fadeIn]>
                    <label class="page__content__field__label">
                        Mês Inicial <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="description" bindValue="number" [searchable]="false"
                        placeholder="Selecione o mês Inicial" notFoundText="Não há items" loadingText="Carregando..."
                        [loading]="loadingFilter" [clearable]="false" [items]="initialMonthsList"
                        (change)="onInitialMonthChange()" formControlName="initialMonth">
                    </ng-select>
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formData.get('initialMonth')?.touched && formData.get('initialMonth')?.value == null">
                        O campo Mês Inicial é obrigatório!
                    </small>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-7 col-md-12 px-2 page__content__field"
                    *ngIf="showValues('finalMonth')" [@fadeIn]>
                    <label class="page__content__field__label">
                        Mês Final <span class="label__form__required">*</span>
                    </label>
                    <ng-select class="page__content__field__dropdown" bindLabel="description" bindValue="number" [searchable]="false"
                        placeholder="Selecione o mês Final" notFoundText="Não há items" loadingText="Carregando..."
                        [loading]="loadingFilter" [clearable]="false" [items]="finalMonthsList"
                        formControlName="finalMonth">
                    </ng-select>
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formData.get('finalMonth')?.touched && formData.get('finalMonth')?.value == null">
                        O campo Mês Final é obrigatório!
                    </small>
                </div>
            </section>
            <section class="mt-2 col-12 p-0">
                <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
                    [disabled]="formData.invalid || disableGenerationBtn() || loading">
                    <div class="d-flex" *ngIf="loading; else showSpan" [@fadeInOut]>
                        <span class="spinner">
                        </span>
                        <span>Solicitando</span>
                    </div>
                    <ng-template #showSpan>
                        <span>Solicitar</span>
                    </ng-template>
                </button>
            </section>
        </form>
    </section>
</main>